import './Copyright.css';

function Copyright() {
  return <div className="copyright">© 2021 1.21jigowatts.</div>;
}

export default Copyright;
